// src/i18n/en.js
import englishMessages from 'ra-language-english';

export default {
    ...englishMessages, // Includes default react-admin translations
    resources: {
        verifications: {
            name: 'Verification Requests',
            rejectTitle: 'Reject Verification',
            selectReason: 'Select rejection reason...',
            customReasonLabel: 'Custom Reason',
            confirmReject: 'Confirm Rejection',
            reasons: {
                 unclear_id_license_photo: 'Unclear ID/License Photo',
                 expired_document: 'Expired Document',
                 information_mismatch: 'Information Mismatch',
                 incomplete_documents: 'Incomplete Documents',
                 profile_picture_unclear_mismatch: 'Profile Picture Unclear/Mismatch',
                 invalid_plate_number_format: 'Invalid Plate Number Format',
                 other: 'Other',
            },
            errors: {
                 reasonRequired: 'Please select a reason for rejection',
                 customReasonRequired: 'Please enter a custom rejection reason',
            }
        },
        // ... (translations for other resources)
    },
    // ... (other custom translations)
};